export default "__VITE_ASSET__DOBNvQVd__"